import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import { formatNumber } from '../../../../../utils/formatacoes';
import { Span } from '../../../../../Themes/Components/AbstractElements';
import Loading from '../../../../../Themes/Components/Loading';
import RegimeMercadoriasService from '../../../../../Services/Regime/RegimeMercadoriasService';

const valoresTributo = (valores) => {
  if (!valores) return '0,00';

  return (
    <div className='py-2' style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
      <div>Valor Calculado: {formatNumber(valores.valor_calculado, 2, 'R$')}</div>
      <div>Valor Reduzido: {formatNumber(valores.valor_reduzido, 2, 'R$')}</div>
      <div>Valor Devido: {formatNumber(valores.valor_devido, 2, 'R$')}</div>
      <div>Valor Suspenso: {formatNumber(valores.valor_suspenso, 2, 'R$')}</div>
      <div>Valor A Recolher: {formatNumber(valores.valor_recolher, 2, 'R$')}</div>
    </div>
  );
};

const HistoricoTributos = ({ id }) => {
  const [columns, setColumns] = useState([]);
  const [tableData, setTableData] = useState({ rows: [], total: 0, page: 1, limit: 20 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const historicoTributos = async () => {
      setLoading(true);

      try {
        const data = await RegimeMercadoriasService.historicoTributos(id);

        setTableData((prev) => ({
          ...prev,
          rows: data.rows,
          total: data.pageInfo.total,
        }));
      } catch (error) {
        toast.error(error.message);
      }

      setLoading(false);
    };

    historicoTributos();
  }, [id]);

  useEffect(() => {
    if (tableData.rows.length === 0) {
      setColumns([]);
      return;
    }

    const apelidos = [];

    tableData.rows.forEach((evento) => {
      evento.tributos.forEach((tributo) => {
        if (!apelidos.includes(tributo.apelido)) {
          apelidos.push(tributo.apelido);
        }
      });
    });

    const colunas = [
      {
        id: 'evento',
        name: 'Evento',
        wrap: true,
        minWidth: '20vw',
        cell: (row) => (
          <div className='py-2'>
            <Span>{row.descricao}</Span>
          </div>
        ),
      },
    ];

    apelidos.forEach((apelido) => {
      colunas.push({
        id: apelido,
        name: apelido,
        right: true,
        wrap: true,
        minWidth: '240px',
        cell: (row) => valoresTributo(row.tributos.find((tributo) => tributo.apelido === apelido)),
      });
    });

    colunas.push({
      id: 'totais',
      name: 'Totais dos Impostos',
      right: true,
      wrap: true,
      minWidth: '240px',
      cell: (row) => valoresTributo(row.totais),
    });

    setColumns(colunas);
  }, [tableData.rows]);

  const handlePageChange = async (page, limit) => {
    setLoading(true);

    try {
      const data = await RegimeMercadoriasService.historicoTributos(id, page, limit);

      setTableData({
        ...tableData,
        rows: data.rows,
        total: data.pageInfo.total,
        page,
        limit,
      });
    } catch (error) {
      toast.error(error.message);
    }

    setLoading(false);
  };

  return (
    <Fragment>
      <DataTable
        columns={columns}
        data={tableData.rows}
        noDataComponent='Nenhum registro encontrado.'
        progressPending={loading}
        progressComponent={<Loading />}
        pagination
        paginationServer={true}
        paginationPerPage={tableData.limit}
        paginationComponentOptions={{
          noRowsPerPage: true,
          rangeSeparatorText: 'de',
        }}
        onChangePage={(page) => handlePageChange(page, tableData.limit)}
        onChangeRowsPerPage={(limit, page) => handlePageChange(page, limit)}
        paginationTotalRows={tableData.total}
      />
    </Fragment>
  );
};

export default HistoricoTributos;